/*
 * Cadwork webgl Engine
 * http://www.lexoview.com
 *
 * Copyright (C) 2015 Cadwork Informatik AG, Basel, Switzerland
 * Dual licensed under the MIT and GPL
 *
 * @author Jaroslav Přibyl (pribyl@cadwork.cz)
 *
 */

import DatLoader from "App/utils/globe/chunk_lod/data/dat_loader";
import IAddress from "App/utils/globe/chunk_lod/adress";

/***
 * Loader for the .dat files for the geometry lod. It includes inside the points mapping, geometry data and jpg texture data with 512x512 resolution
 * @constructor
 */
export default
class PointsMapper {
    private _address: IAddress;
    private _dataView: DataView;
    private _mappingsOffsets: any;

    constructor(aAddress: IAddress) {
        this._address = aAddress;
        this._dataView = null;
        this._mappingsOffsets = {};
    }

    public fill(aLoader: DatLoader) {
        this._dataView = new DataView(aLoader.getPointMappingBuffer());

        let nofMappingRecords = 0;
        for (let level = this._address.level; level < this._address.patchInfo.levels; level++) {
            this._mappingsOffsets[level] = nofMappingRecords; // compute offset to the mapping level
            nofMappingRecords += Math.pow(aLoader.getNC(), level - this._address.level);
        }
    }

    public getNodePointsPositionsOffsetAndSize(aAddress: IAddress): {offset: number, size: number} {
        let coef = Math.pow(2, aAddress.level - this._address.level);
        let index = (aAddress.layer % coef) * Math.pow(4, aAddress.level - this._address.level) + (aAddress.row % coef) * coef + (aAddress.col % coef);

        return {
            offset: this._dataView.getInt32(this._mappingsOffsets[aAddress.level] * 2 * 4 + index * 2 * 4, true) * 3 * 4,
            size: this._dataView.getInt32(this._mappingsOffsets[aAddress.level] * 2 * 4 + index * 2 * 4 + 4, true) * 3 * 4
        };
    }

    public getNodePointsNormalsOffsetAndSize(aAddress: IAddress): {offset: number, size: number}  {
        let coef = Math.pow(2, aAddress.level - this._address.level);
        let index = (aAddress.layer % coef) * Math.pow(4, aAddress.level - this._address.level) + (aAddress.row % coef) * coef + (aAddress.col % coef);

        return {
            offset: this._dataView.getInt32(this._mappingsOffsets[aAddress.level] * 2 * 4 + index * 2 * 4, true) * 3 * 4,
            size: this._dataView.getInt32(this._mappingsOffsets[aAddress.level] * 2 * 4 + index * 2 * 4 + 4, true) * 3 * 4
        };
    }

    public getNodePointsTexCoordsOffsetAndSize(aAddress: IAddress): {offset: number, size: number}  {
        let coef = Math.pow(2, aAddress.level - this._address.level);
        let index = (aAddress.layer % coef) * Math.pow(4, aAddress.level - this._address.level) + (aAddress.row % coef) * coef + (aAddress.col % coef);

        return {
            offset: this._dataView.getInt32(this._mappingsOffsets[aAddress.level] * 2 * 4 + index * 2 * 4, true) * 2 * 4,
            size: this._dataView.getInt32(this._mappingsOffsets[aAddress.level] * 2 * 4 + index * 2 * 4 + 4, true) * 2 * 4
        };
    }

    public getNodePointsLayersOffsetAndSize(aAddress: IAddress): {offset: number, size: number}  {
        let coef = Math.pow(2, aAddress.level - this._address.level);
        let index = (aAddress.layer % coef) * Math.pow(4, aAddress.level - this._address.level) + (aAddress.row % coef) * coef + (aAddress.col % coef);

        return {
            offset: this._dataView.getInt32(this._mappingsOffsets[aAddress.level] * 2 * 4 + index * 2 * 4, true) * 1 * 4,
            size: this._dataView.getInt32(this._mappingsOffsets[aAddress.level] * 2 * 4 + index * 2 * 4 + 4, true) * 1 * 4
        };
    }

    public getNodePointsSurfaceStyleOffsetAndSize(aAddress: IAddress): {offset: number, size: number}  {
        let coef = Math.pow(2, aAddress.level - this._address.level);
        let index = (aAddress.layer % coef) * Math.pow(4, aAddress.level - this._address.level) + (aAddress.row % coef) * coef + (aAddress.col % coef);

        return {
            offset: this._dataView.getInt32(this._mappingsOffsets[aAddress.level] * 2 * 4 + index * 2 * 4, true) * 1 * 4,
            size: this._dataView.getInt32(this._mappingsOffsets[aAddress.level] * 2 * 4 + index * 2 * 4 + 4, true) * 1 * 4
        };
    }
}
